export default __webpack_public_path__ + "static/media/ipbillAction.16c908fd.svg";